import * as React from 'react'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import {LoginInputs} from '../../Components/LoginForm/LoginFormView'
import {LoginFormAction} from '../../Components/LoginForm/LoginFormActions'
import {LoginForm} from '../../Components/LoginForm/LoginFormState'

export function ReloginView({state, dispatch}: {
    state: LoginForm,
    dispatch: (action: LoginFormAction) => void,
}) {
    return (
        <Dialog
            title="Sitzungserneuerung"
            modal={true}
            open={true}
        >
            <form
                onSubmit={(event) => {
                    event.preventDefault()
                    dispatch({type: 'Submit'})
                }}
            >
                <p>
                    Ihre Sitzung ist abgelaufen. Bitte authentifizieren Sie sich
                    erneut.
                </p>
                <LoginInputs
                    autofocus={'Password'}
                    state={state}
                    dispatch={dispatch}
                />
                <div
                    style={{
                        textAlign: 'right',
                        padding: 8,
                        margin: '24px -24px -24px -24px'
                    }}
                >
                    <FlatButton
                        label="Logout"
                        onTouchTap={() => dispatch({type: 'Logout'})}
                    />
                    <FlatButton
                        label="Login"
                        primary={true}
                        type="submit"
                        disabled={state.loading}
                    />
                </div>
            </form>
        </Dialog>)
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/Relogin/ReloginView.tsx